import React, { useState, useEffect } from "react";
import { Modal, Button, Form, InputGroup } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { addDiscount, updateDiscount } from "../../../redux/reducers/discountSlice";
import { FaPlus, FaRegEdit } from "react-icons/fa";
import Spinner from "../../../components/Spinner";

export default function AddDiscount({ type, data }) {
    const [show, setShow] = useState(false);
    const dispatch = useDispatch();
    const selectedBusiness = useSelector((state) => state.business.selectedBusiness);
    const { loading } = useSelector((state) => state.discount);
    const businessId = selectedBusiness?._id || localStorage.getItem("activeBusinessId");

    const [formData, setFormData] = useState({
        name: "",
        type: "percentage",
        value: "",
        status: "active",
    });

    useEffect(() => {
        if (type === "update" && data) {
            setFormData({
                name: data.name,
                type: data.type,
                value: data.value,
                status: data.status,
            });
        }
    }, [type, data]);

    const handleClose = () => {
        if (loading) return;
        setShow(false);
        if (type === "add") {
            setFormData({ name: "", type: "percentage", value: "", status: "active" });
        }
    };

    const handleShow = () => setShow(true);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const payload = { ...formData, businessId };
        if (type === "update") {
            dispatch(updateDiscount({ ...payload, id: data._id })).then((res) => {
                if (!res.error) handleClose();
            });
        } else {
            dispatch(addDiscount(payload)).then((res) => {
                if (!res.error) handleClose();
            });
        }
    };

    return (
        <div className="d-inline-block">
            {type === "add" ? (
                <Button className="btn btn-primary d-flex align-items-center gap-2" onClick={handleShow}>
                    <FaPlus /> New Discount
                </Button>
            ) : (
                <div onClick={handleShow} className="action-icon-edit text-primary p-2 rounded-circle bg-light d-flex align-items-center justify-content-center cursor-pointer" title="Edit Discount">
                  <FaRegEdit size={16} />
                </div>
            )}

            <Modal 
              show={show} 
              onHide={handleClose} 
              centered 
              backdrop="static"
              className="premium-modal"
            >
                <Modal.Header closeButton={!loading} className="border-0 pb-0">
                    <Modal.Title className="fw-bold brand-header">
                        {type === "update" ? "Update Discount" : "Create New Discount"}
                    </Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleSubmit}>
                    <Modal.Body className="pt-4">
                        <Spinner active={loading}>
                            <Form.Group className="mb-3">
                                <Form.Label className="fw-medium text-secondary small">Discount Name <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    name="name"
                                    placeholder="e.g. Seasonal, Loyalty"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                    className="gbl-input"
                                    disabled={loading}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label className="fw-medium text-secondary small">Type</Form.Label>
                                <div className="d-flex gap-4 mt-1">
                                    <Form.Check
                                        type="radio"
                                        label="Percentage (%)"
                                        name="type"
                                        value="percentage"
                                        checked={formData.type === "percentage"}
                                        onChange={handleChange}
                                        id="type-percentage"
                                        disabled={loading}
                                        className="small fw-semibold"
                                    />
                                    <Form.Check
                                        type="radio"
                                        label="Flat Amount ($)"
                                        name="type"
                                        value="flat"
                                        checked={formData.type === "flat"}
                                        onChange={handleChange}
                                        id="type-flat"
                                        disabled={loading}
                                        className="small fw-semibold"
                                    />
                                </div>
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label className="fw-medium text-secondary small">Value <span className="text-danger">*</span></Form.Label>
                                <InputGroup className="overflow-hidden rounded-3">
                                    {formData.type === "flat" && <InputGroup.Text className="bg-light border-end-0">$</InputGroup.Text>}
                                    <Form.Control
                                        type="number"
                                        name="value"
                                        placeholder="0.00"
                                        step="0.01"
                                        value={formData.value}
                                        onChange={handleChange}
                                        required
                                        className="gbl-input"
                                        disabled={loading}
                                    />
                                    {formData.type === "percentage" && <InputGroup.Text className="bg-light border-start-0">%</InputGroup.Text>}
                                </InputGroup>
                            </Form.Group>

                            <Form.Group className="mb-3 border-top pt-3">
                                <Form.Label className="fw-medium text-secondary small">Status</Form.Label>
                                <Form.Select 
                                  name="status" 
                                  value={formData.status} 
                                  onChange={handleChange} 
                                  className="gbl-input"
                                  disabled={loading}
                                >
                                    <option value="active">Active</option>
                                    <option value="inactive">Inactive</option>
                                </Form.Select>
                            </Form.Group>
                        </Spinner>
                    </Modal.Body>
                    <Modal.Footer className="border-0 pt-0 pb-4 px-4 d-flex justify-content-end gap-2">
                        <Button 
                          variant="light" 
                          onClick={handleClose} 
                          className="px-4 fw-bold text-secondary rounded-pill"
                          disabled={loading}
                        >
                            Cancel
                        </Button>
                        <Button 
                          type="submit" 
                          className="btn btn-primary px-4 rounded-pill fw-bold shadow-sm"
                          disabled={loading}
                        >
                            {loading ? "Saving..." : (type === "update" ? "Update Discount" : "Create Discount")}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </div>
    );
}
